import React from 'react';
import BaseAssetClasses from '@/creditflowresearch/ui/components/bonds/common/AssetClasses/BaseAssetClasses';
import { useTraceAssetClassesContext } from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';
import { IAssetClass } from '@/creditflowresearch/domain/vo/IAssetClass';
import { useTraceTableContext } from '@/creditflowresearch/application/Trace/TraceTableContext';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import useGetTracePayload from '@/creditflowresearch/application/Trace/useGetTracePayload';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { checkAccess } from '@/creditflowresearch/application/User/access/checkAccess';

const AssetClasses = () => {
  const { assetsClasses, handleAssetClassClick } = useTraceAssetClassesContext();
  const { getTrades, isTraceFetching } = useTraceTableContext();
  const { handlePageChange } = useFiltersContext();
  const { checkAccessByUserPlan } = useUserPlanContext();
  const { checkAccessByUserRegions, checkAccessByUserProducts } = usePageFiltersContext();
  const checks = [
    !isTraceFetching,
    checkAccessByUserPlan(UserPlanType.PRO),
    checkAccessByUserRegions(),
    checkAccessByUserProducts(),
  ];

  const isAllDisabled = !checkAccess(checks);

  const { getPayload } = useGetTracePayload();

  const onClick = (assetClass: IAssetClass) => {
    handleAssetClassClick(assetClass);
    handlePageChange(1);
    getTrades(getPayload({ assetClassId: assetClass.id }));
  };

  return (
    <BaseAssetClasses
      assetClassCollection={ assetsClasses }
      isAllDisabled={ isAllDisabled }
      handleAssetClassClick={ onClick }
    />
  );
};

export default AssetClasses;
